module.exports = __webpack_public_path__ + "img/pic3.1d409f30.jpg";